export default {
    state: {
        presupuestos: [],
        loading: false,
    },
    getters: {
        presupuestos: (state) => state.presupuestos,
        loading: state => state.loading,
    },
    mutations: {
        SET_PRESUPUESTOS: (state, payload) => state.presupuestos = payload,
        setLoading: (state, payload) => state.loading = payload,
    },
    actions: {
        fetch({commit}, payload) {
          this.dispatch('index', payload)
            .then((response) => {
              commit('SET_PRESUPUESTOS', response.datos)
            })
        },
        listaUsuarios({commit, dispatch}, payload) {
            return new Promise((res, rej) => {
                this.getters.api.get('/exportar/usuarios', {
                    responseType: 'blob',
                })
                .then((response) => {
                    res(response)
                }).catch((error) => {
                    rej(error)
                });
            });
        },
        importarPresupuesto({commit, dispatch}, payload) {
            return new Promise((res, rej) => {
                this.getters.api.post('/presupuesto/importar', payload)
                .then(response => {
                    res(response)
                }).catch(error =>
                    rej(error)
                )
            })
        },
        datosGrafica({commit, dispatch}, payload) {
            return new Promise((res, rej) => {
                this.getters.api.post('/utilidades/grafica-presupuesto', payload)
                .then(response => {
                    res(response.data)
                }).catch(error =>
                    rej(error)
                )
            })
        },

    }
}